import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import React from "react";

interface NotQualifyDialogProps {
  disQualifyReason: string;
  onClick: () => void;
}

export const NotQualifyDialog = ({
  disQualifyReason,
  onClick,
}: NotQualifyDialogProps) => (
  <TwoButtonDialog
    type="warning"
    title={`抱歉\\n個案不符合申請資格${disQualifyReason ? ('\\n' + disQualifyReason) : ''}`}
    leftLabel="了解"
    leftOnClick={onClick}
    leftIconName="fa-check"
  />
)